<template>
  <div>
    <span class="ljf" @click="start">点击欣赏</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
    
    };
  },
  methods: {
    start() {
     window.location.href = 'http://qkongtao.cn/file/longjuanfeng/ljf.html'; 
    }
  },
};
</script>

<style lang="scss" scoped>
.ljf {
  position: absolute;
  width: 100%;
  text-align: center;
  top: 200px;
  font-family: 隶书;
  font-size: 45px;
  line-height: 45px;
  color: rgb(255, 0, 0);
}
</style>


// WEBPACK FOOTER //
// src/components/tabbar/ShopcarContainer.vue